import apiHandler from "../core/apiHandler";

const taxCreditPurchaseApi = apiHandler('tax-credit-purchases');
export default taxCreditPurchaseApi;
